<template>
  <div class="teams-category-page">
    <div class="container">
      <Toolbar title-tag="h1" class="teams-category-page__toolbar">
        <template #title>Команды</template>
        <template #default>
          <div class="teams-category-page__city">{{ cityName }}</div>
          <div v-if="cities" class="teams-category-page__sort">
            <div class="teams-category-page__select-label">Сортировать по:</div>
            <AppSelect
              class="teams-category-page__select"
              :options="cities"
              :value="slug"
              theme="second"
              value-key="id"
              label-key="name"
              @change="changeCity"
            />
          </div>
        </template>
      </Toolbar>
      <TeamsList :slug="slug" />
    </div>
  </div>
</template>

<script>
import TeamsList from "@/components/teams/TeamsList";
import { Toolbar } from "@/components/ui/toolbar/";
import { mapState, mapActions } from "vuex";

export default {
  name: "TeamsCategoriyPage",

  components: {
    TeamsList,
    Toolbar
  },

  data: () => ({
    loading: true
  }),

  computed: {
    ...mapState("dictionaries", {
      city({ dictionaries }) {
        const { cities } = dictionaries;
        if (!cities) return;
        return cities.find(item => item.id === this.slug);
      },
      cities: ({ dictionaries }) => dictionaries.cities
    }),

    cityName() {
      return this.city ? this.city.name : "Город";
    },

    slug() {
      return +this.$route.params.slug;
    }
  },

  async created() {
    await this.loadCities();
    this.checkCity();
  },

  methods: {
    ...mapActions("dictionaries", ["getDictionary"]),
    async loadCities() {
      this.loading = true;
      await this.getDictionary("cities");
      this.loading = false;
    },
    checkCity() {
      if (!this.city) {
        this.$router.replace("/404");
      }
    },
    changeCity(citySlug) {
      this.$router.replace({
        name: "teams-category",
        params: { slug: citySlug }
      });
    }
  },

  breadcrumb() {
    const { cityName, slug } = this;
    return {
      title: cityName,
      to: {
        name: "teams-category",
        params: { slug }
      }
    };
  }
};
</script>

<style lang="scss">
.teams-category-page {
  &__toolbar {
    position: relative;
    z-index: 5;
  }

  &__city {
    position: absolute;
    top: -15px;
    left: -10px;
    min-width: 180px;
    height: 45px;
    background: url("~@/assets/images/other/city-bg.png") 0 0 no-repeat;
    font-size: 20px;
    line-height: 45px;
    padding-left: 10px;
    text-transform: uppercase;
    font-weight: fw(bold);
  }

  &__sort {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  &__select {
    width: 230px;
    position: relative;
    z-index: 2;
    text-transform: uppercase;
  }

  &__select-label {
    text-transform: uppercase;
    font-size: 15px;
    font-weight: fw(bold);
    color: colors(text-3);
    margin-right: 10px;
    text-align: right;
  }

  @include breakpoint("sm-and-down") {
    &__sort {
      margin-right: auto;
    }
  }

  @include breakpoint("xs-only") {
    &__sort {
      flex-wrap: wrap;
    }
    &__select-label {
      margin-bottom: 5px;
    }
  }
}
</style>
